import { Box, Container, Heading, Text, Stack } from '@chakra-ui/react'
import { Link } from 'react-router-dom'

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <Box>
      <Heading size="md" color="white" mb={3}>{title}</Heading>
      {children}
    </Box>
  )
}

function P({ children }: { children: React.ReactNode }) {
  return <Text color="rgba(255,255,255,0.7)" lineHeight="1.8" mb={3}>{children}</Text>
}

function Li({ children }: { children: React.ReactNode }) {
  return <Text as="li" color="rgba(255,255,255,0.7)" lineHeight="1.8" mb={1}>{children}</Text>
}

export default function TermsOfUse() {
  return (
    <Box bg="black" minH="100vh" py={16} px={4}>
      <Container maxW="800px">
        <Stack gap={10}>
          <Box textAlign="center">
            <Heading color="white" fontSize={{ base: '2xl', md: '3xl' }} mb={2}>
              Kullanım Koşulları
            </Heading>
            <Text color="rgba(255,255,255,0.4)" fontSize="sm">Son güncelleme: 12 Nisan 2026</Text>
            <Text color="rgba(255,255,255,0.4)" fontSize="sm">3d-yazdir.com</Text>
          </Box>

          <Stack gap={8}>
            <Section title="1. Taraflar ve Kapsam">
              <P>
                Bu Kullanım Koşulları, 3d-yazdir.com ("Platform") ile Platformu kullanan bireyler ve baskı firmaları
                ("Kullanıcı") arasındaki hizmet ilişkisini düzenlemektedir. Platforma kayıt olarak veya hizmetlerden
                yararlanarak bu koşulları kabul etmiş sayılırsınız.
              </P>
              <P>
                Platform; 3D model yükleme, fiyat hesaplama, baskı firması seçimi, sipariş yönetimi ve ödeme
                işlemlerini kapsayan bir SaaS (Hizmet Olarak Yazılım) hizmetidir.
              </P>
            </Section>

            <Section title="2. Hesap Türleri">
              <P><strong style={{ color: 'white' }}>2.1 Kullanıcı Hesabı:</strong></P>
              <Box as="ul" pl={5} mb={3}>
                <Li>3D model yükleyebilir, fiyat teklifi alabilir ve sipariş verebilir</Li>
                <Li>Baskı firmaları arasından tercih yapabilir</Li>
                <Li>Sipariş geçmişini ve takibini görüntüleyebilir</Li>
                <Li>Firmalarla mesajlaşabilir</Li>
              </Box>
              <P><strong style={{ color: 'white' }}>2.2 Baskı Firması Hesabı:</strong></P>
              <Box as="ul" pl={5} mb={3}>
                <Li>Firma profili oluşturabilir; logo, açıklama, malzeme bilgileri girebilir</Li>
                <Li>Firma hesabı oluşturulduktan sonra Platform yönetici onayına sunulur</Li>
                <Li>Onay alınmadan firma, sipariş listelerinde ve kamuya açık sayfada görünmez</Li>
                <Li>Onay sonrasında kendisine atanan siparişleri görüntüleyebilir, üretim durumunu güncelleyebilir</Li>
                <Li>Müşterilerle platform üzerinden mesajlaşabilir</Li>
              </Box>
              <P>
                Hesap bilgilerinin doğruluğundan Kullanıcı sorumludur. Yanlış veya yanıltıcı bilgi verilmesi
                hesabın kapatılmasına yol açabilir.
              </P>
            </Section>

            <Section title="3. Sipariş Süreci">
              <P><strong style={{ color: 'white' }}>3.1 Sipariş oluşturma:</strong></P>
              <P>
                Kullanıcı, 3D model dosyasını yükler; malzeme, kalite, renk ve doluluk oranı seçer; fiyat teklifini
                görür ve ödeme adımına geçer. Kullanıcı bu aşamada onaylı baskı firmalarından birini seçebilir ya da
                seçimi Platform'a bırakabilir.
              </P>
              <P><strong style={{ color: 'white' }}>3.2 Firma ataması:</strong></P>
              <P>
                Kullanıcı bir firma seçmediyse Platform, uygun onaylı bir firmayı atar. Sipariş, seçilen veya
                atanan firmaya iletilir. Firma, siparişi Üretimde / Tamamlandı / İptal olarak güncelleyebilir.
              </P>
              <P><strong style={{ color: 'white' }}>3.3 Üretim ve teslimat:</strong></P>
              <P>
                Sipariş firmasına iletildikten sonra üretim başlar. Tahmini teslimat süresi firmaya ve seçilen
                malzemeye göre değişir. Takip numarası kargo aşamasında sisteme girilir ve Kullanıcı sipariş
                detay sayfasından takip edebilir.
              </P>
            </Section>

            <Section title="4. Ödeme Koşulları">
              <P>
                Ödemeler Stripe ödeme altyapısı üzerinden güvenli biçimde gerçekleştirilir. Sipariş tutarı,
                ödeme onayı alındığında tahsil edilir. Platform, KDV dahil fiyatlandırma yapar; faturalar
                talep halinde iletilir.
              </P>
              <P>
                Firma hesapları, tamamlanan siparişlere ilişkin ödeme bilgilerini kendi panellerinden
                görüntüleyebilir. Platform, ödeme dağıtımını proje sözleşmesine uygun şekilde yönetir.
              </P>
            </Section>

            <Section title="5. İade ve İptal Politikası">
              <P><strong style={{ color: 'white' }}>5.1 Üretim başlamadan önce iptal:</strong></P>
              <P>
                Sipariş "Ödendi" aşamasında ise, üretim henüz başlamadıysa müşteri iptal talebinde
                bulunabilir. Tam iade yapılır.
              </P>
              <P><strong style={{ color: 'white' }}>5.2 Üretim başladıktan sonra iptal:</strong></P>
              <P>
                Üretim başladıktan sonra iptal kabul edilmeyebilir veya kısmi iade yapılabilir; durum
                firmaya ve üretim aşamasına göre değerlendirilir.
              </P>
              <P><strong style={{ color: 'white' }}>5.3 Kusurlu ürün:</strong></P>
              <P>
                Teslimat sonrasında ürünün hasarlı veya sipariş detaylarına uygunsuz olduğu anlaşılırsa,
                teslimat tarihinden itibaren 7 gün içinde Platform destek ekibine başvurulması gerekir.
                Durum incelenerek tam veya kısmi iade ya da yeniden üretim kararlaştırılır.
              </P>
              <P>
                İade talepleri <strong style={{ color: 'white' }}>contact@3d-yazdir.com</strong> adresine
                iletilmelidir.
              </P>
            </Section>

            <Section title="6. 3D Model Dosyaları ve Fikri Mülkiyet">
              <P>
                Platforma yüklediğiniz 3D model dosyalarının fikri mülkiyet hakları size aittir. Platform,
                dosyaları yalnızca baskı işlemi ve sipariş yönetimi amacıyla kullanır; üçüncü taraflarla
                paylaşmaz.
              </P>
              <P>
                Başkasına ait telif hakkıyla korunan bir modeli izinsiz yüklemek yasaktır. Bu tür
                ihlallerden doğan hukuki ve cezai sorumluluk tamamen yükleyen kullanıcıya aittir.
              </P>
              <P>
                Platform üzerinde pazarda paylaşılan modeller, model sahibinin belirlediği lisans
                koşullarına tabidir.
              </P>
            </Section>

            <Section title="7. Baskı Firmalarının Yükümlülükleri">
              <Box as="ul" pl={5} mb={3}>
                <Li>Kayıt sırasında doğru ve güncel bilgi sunmak</Li>
                <Li>Yönetici onayı olmadan kendilerini onaylı firma olarak tanıtmamak</Li>
                <Li>Atanan siparişleri belirlenen kalite standartlarında yerine getirmek</Li>
                <Li>Sipariş durumunu gerçek zamanlı olarak güncellemek</Li>
                <Li>Müşteri mesajlarına makul sürede yanıt vermek</Li>
                <Li>Müşteri kişisel verilerini yalnızca sipariş işleme amacıyla kullanmak</Li>
              </Box>
            </Section>

            <Section title="8. Yasaklı İçerik ve Kullanımlar">
              <P>Aşağıdaki kullanımlar kesinlikle yasaktır:</P>
              <Box as="ul" pl={5} mb={3}>
                <Li>Yasadışı, tehlikeli veya zarar verici ürünlerin baskısına yönelik siparişler</Li>
                <Li>Silah, mühimmat veya bu amaçla kullanılabilecek parçaların üretimi</Li>
                <Li>Başkasına ait telif hakkıyla korunan dosyaların izinsiz yüklenmesi</Li>
                <Li>Sistemi manipüle etmeye yönelik otomatik araç veya botlar kullanmak</Li>
                <Li>Sahte hesap oluşturmak veya başkasının kimliğine bürünmek</Li>
                <Li>Platformun altyapısına zarar vermeye yönelik saldırılar</Li>
              </Box>
            </Section>

            <Section title="9. Platform'un Sorumluluğunun Sınırları">
              <P>
                Platform, baskı firmaları tarafından gerçekleştirilen üretimin kalitesini garanti etmez;
                bununla birlikte uyuşmazlıklarda arabuluculuk hizmeti sunar.
              </P>
              <P>
                Platform, doğrudan kontrol dışındaki teknik arızalar, üçüncü taraf hizmet kesintileri
                (ödeme sistemleri, kargo vb.) veya mücbir sebepler nedeniyle oluşan zararlardan sorumlu tutulamaz.
              </P>
              <P>
                Platformun herhangi bir nedenle kullanılamaz hale gelmesinden kaynaklanan dolaylı zararlar
                için sorumluluk kabul edilmez.
              </P>
            </Section>

            <Section title="10. Hesap Askıya Alma ve Kapatma">
              <P>
                Platform, bu Kullanım Koşullarını ihlal eden, hileli faaliyette bulunan veya diğer
                kullanıcılara zarar veren hesapları önceden bildirimde bulunmaksızın askıya alma veya
                kapatma hakkını saklı tutar.
              </P>
              <P>
                Hesabını kapatmak isteyen kullanıcılar Ayarlar sayfasından veya <strong style={{ color: 'white' }}>contact@3d-yazdir.com</strong> adresi
                üzerinden talepte bulunabilir. Açık siparişlerin tamamlanması beklendikten sonra hesap kapatılır.
              </P>
            </Section>

            <Section title="11. Uygulanacak Hukuk ve Uyuşmazlık Çözümü">
              <P>
                Bu Kullanım Koşulları Türk hukukuna tabidir. Taraflar arasında doğacak uyuşmazlıklarda
                öncelikle müzakere yoluyla çözüm aranır. Çözüme kavuşturulamazsa İstanbul Mahkemeleri
                ve İcra Daireleri yetkilidir.
              </P>
            </Section>

            <Section title="12. Koşulların Güncellenmesi">
              <P>
                Platform bu Kullanım Koşullarını dilediği zaman güncelleme hakkına sahiptir. Önemli
                değişiklikler 30 gün öncesinden platform üzerinde duyurulur. Değişiklik sonrasında hizmeti
                kullanmaya devam etmeniz yeni koşulları kabul ettiğiniz anlamına gelir.
              </P>
            </Section>

            <Section title="13. İletişim">
              <P>Bu koşullarla ilgili sorularınız için:</P>
              <Box as="ul" pl={5}>
                <Li>E-posta: contact@3d-yazdir.com</Li>
                <Li>Hukuki talepler: legal@3d-yazdir.com</Li>
              </Box>
              <Text color="rgba(255,255,255,0.5)" fontSize="sm" mt={4}>
                Ayrıca{' '}
                <Link to="/tr/gizlilik" style={{ color: '#CCF301' }}>
                  Gizlilik Politikası
                </Link>
                'mızı incelemenizi tavsiye ederiz.
              </Text>
            </Section>
          </Stack>
        </Stack>
      </Container>
    </Box>
  )
}
